import initialCameraProps from 'helpers/cameras/initialCameraProps'
import initialPresentationValues from 'helpers/presentation/initialPresentationValues'

export default function addCamera(state, action) {
  const { location, id, distance } = action

  const camera = Object.assign(
    {},
    initialCameraProps(id, !state.ui.isImperial, distance),
    { active: false, location, newlyAdded: true },
    { name: `Camera ${state.cameras.filter(c => !c.imagerId).length + 1}` }
  )

  return Object.assign({}, state, {
    currentEntity: {
      id,
      type: 'camera'
    },
    cameras: [
      ...state.cameras,
      camera
    ],
    presentationValues: initialPresentationValues(camera)
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addCamera.js